/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number Base Converter — Binary, Octal, Decimal, Hex | Toolverse`)
};

const es_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Bases Numéricas — Binario, Octal, Decimal, Hex | Toolverse`)
};

const de_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlenbasis-Umrechner — Binär, Oktal, Dezimal, Hex | Toolverse`)
};

const nl_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getalbasiscalculator — Binair, Octaal, Decimaal, Hex | Toolverse`)
};

const fr_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de base numérique — Binaire, Octal, Décimal, Hexadécimal | Toolverse`)
};

const it_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number Base Converter — Binario, Ottale, Decimale, Esadecimale | Toolverse`)
};

const pt_br2_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Bases Numéricas — Binário, Octal, Decimal, Hex | Toolverse`)
};

const pt_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Base de Números — Binário, Octal, Decimal, Hexadecimal | Toolverse`)
};

const ja_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値ベース変換ツール — 二進法、八進法、十進法、十六進法 | Toolverse`)
};

const zh_nb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进制转换器 — 二进制、八进制、十进制、十六进制 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_meta_title", locale)
	if (locale === "en") return en_nb_meta_title(inputs)
	if (locale === "es") return es_nb_meta_title(inputs)
	if (locale === "de") return de_nb_meta_title(inputs)
	if (locale === "nl") return nl_nb_meta_title(inputs)
	if (locale === "fr") return fr_nb_meta_title(inputs)
	if (locale === "it") return it_nb_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_nb_meta_title(inputs)
	if (locale === "pt") return pt_nb_meta_title(inputs)
	if (locale === "ja") return ja_nb_meta_title(inputs)
	return zh_nb_meta_title(inputs)
};